import { trigger, state, style, transition, animate } from '@angular/animations';

export const expandMenu = trigger('expandMenu', [
	state('*', style({ height: '*', visibility: 'visible' })),
	state('void', style({ height: '0', visibility: 'hidden' })),
	transition(':enter', animate('200ms ease-in')),
	transition(':leave', animate('200ms ease-out'))
]);
